import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {WorkPlace} from '../classes/WorkPlace';
import {environment} from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class WorkPlaceService {

  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<WorkPlace[]> {
    return this.httpClient.get<WorkPlace[]>(`${environment.backendApiUrl}/v1/workplaces`);
  }

  public addOrEdit(editedWorkPlace: WorkPlace): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/workplaces`, editedWorkPlace, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/workplaces/` + id, httpOptions);
  }
}
